(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nom-hypnos-pdp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      const gallerySlides = [...section.querySelectorAll('[data-gallery-slide]')];
      const galleryThumbs = [...section.querySelectorAll('[data-gallery-thumb]')];

      galleryThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const target = thumb.dataset.galleryThumb;
          gallerySlides.forEach((slide) => {
            slide.hidden = slide.dataset.gallerySlide !== target;
          });
          galleryThumbs.forEach((item) => {
            const selected = item === thumb;
            item.classList.toggle('is-active', selected);
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
          });
        });

        thumb.addEventListener('keydown', (event) => {
          const currentIndex = galleryThumbs.indexOf(thumb);
          let targetIndex = currentIndex;
          if (event.key === 'ArrowRight') targetIndex = (currentIndex + 1) % galleryThumbs.length;
          if (event.key === 'ArrowLeft') targetIndex = (currentIndex - 1 + galleryThumbs.length) % galleryThumbs.length;
          if (event.key === 'Home') targetIndex = 0;
          if (event.key === 'End') targetIndex = galleryThumbs.length - 1;
          if (targetIndex === currentIndex) return;
          event.preventDefault();
          galleryThumbs[targetIndex].focus();
          galleryThumbs[targetIndex].click();
        });
      });

      const productDetails = [...section.querySelectorAll('.nom-hypnos__product-details details')];
      productDetails.forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (!detail.open) return;
          productDetails.forEach((otherDetail) => {
            if (otherDetail !== detail) otherDetail.open = false;
          });
        });
      });

      const subscriptionInput = section.querySelector('[data-nom-subscription]');
      const oneTimeInput = section.querySelector('[data-nom-one-time]');
      const sellingPlanSelect = section.querySelector('[data-nom-selling-plan]');
      const subscriptionCard = section.querySelector('[data-purchase-card="subscription"]');
      const oneTimeCard = section.querySelector('[data-purchase-card="one-time"]');
      const selectedPrice = section.querySelector('[data-selected-price]');
      const secondaryPlanInputs = [...section.querySelectorAll('[data-secondary-selling-plan]')];

      const syncPurchase = () => {
        const isSubscription = subscriptionInput?.checked !== false;
        subscriptionCard?.classList.toggle('is-selected', isSubscription);
        oneTimeCard?.classList.toggle('is-selected', !isSubscription);
        if (sellingPlanSelect) sellingPlanSelect.disabled = !isSubscription;

        const selectedOption = sellingPlanSelect?.selectedOptions?.[0];
        if (isSubscription && selectedPrice && selectedOption?.dataset.planPriceFormatted) {
          selectedPrice.textContent = selectedOption.dataset.planPriceFormatted;
        }

        secondaryPlanInputs.forEach((input) => {
          input.disabled = !isSubscription;
          if (isSubscription && sellingPlanSelect) input.value = sellingPlanSelect.value;
        });
      };

      subscriptionInput?.addEventListener('change', syncPurchase);
      oneTimeInput?.addEventListener('change', syncPurchase);
      sellingPlanSelect?.addEventListener('change', syncPurchase);
      syncPurchase();

      const primaryForm = section.querySelector('[data-nom-hypnos-buy-box] form');
      primaryForm?.addEventListener('formdata', (event) => {
        event.formData.delete('purchase_type');
        if (!event.formData.get('selling_plan')) event.formData.delete('selling_plan');
      });

      const purchaseForms = [...section.querySelectorAll('form[data-product-form]')];
      let pendingResetTimer;
      const setPurchasePending = (form, isPending) => {
        const button = form.querySelector('[data-add-to-cart]');
        if (!button) return;
        if (!button.dataset.idleText) button.dataset.idleText = button.textContent.trim();
        form.dataset.nomCartAddPending = String(isPending);
        button.setAttribute('aria-busy', String(isPending));
        button.disabled = isPending || button.dataset.idleText === 'Sold Out';
        button.textContent = isPending ? 'Adding…' : button.dataset.idleText;
      };
      const resetPurchasePending = () => {
        window.clearTimeout(pendingResetTimer);
        purchaseForms.forEach((form) => setPurchasePending(form, false));
      };
      purchaseForms.forEach((form) => {
        form.addEventListener('submit', () => {
          setPurchasePending(form, true);
          window.clearTimeout(pendingResetTimer);
          pendingResetTimer = window.setTimeout(resetPurchasePending, 8000);
        });
      });
      document.addEventListener('theme:cart:added', resetPurchasePending);
      document.addEventListener('nom:cart:updated', resetPurchasePending);

      const stickyPurchase = section.querySelector('[data-nom-sticky-purchase]');
      const stickySentinel = section.querySelector('[data-nom-sticky-sentinel]');
      if (stickyPurchase && stickySentinel && 'IntersectionObserver' in window) {
        const stickyActivationTarget = section.querySelector('.nom-hypnos__hero-content [data-add-to-cart]') || stickySentinel;
        const stickyBoundary = section.querySelector('.nom-hypnos__reviews');
        let stickyReady = false;
        let stickyBlocked = false;
        const syncSticky = () => {
          const shouldShow = stickyReady && !stickyBlocked;
          stickyPurchase.classList.toggle('is-visible', shouldShow);
          stickyPurchase.setAttribute('aria-hidden', String(!shouldShow));
        };
        const stickyObserver = new IntersectionObserver(([entry]) => {
          stickyReady = !entry.isIntersecting && entry.boundingClientRect.bottom <= 8;
          syncSticky();
        });
        stickyObserver.observe(stickyActivationTarget || stickySentinel);

        if (stickyBoundary) {
          const stickyBoundaryObserver = new IntersectionObserver(([entry]) => {
            stickyBlocked = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
            syncSticky();
          });
          stickyBoundaryObserver.observe(stickyBoundary);
        }
      }

      const ingredientTrack = section.querySelector('[data-ingredient-track]');
      const ingredientDots = [...section.querySelectorAll('[data-ingredient-dot]')];
      const initIngredientCarousel = () => {
        if (!ingredientTrack || ingredientTrack.dataset.infiniteCarousel) return;
        ingredientTrack.dataset.infiniteCarousel = 'true';
        const originalCards = [...ingredientTrack.querySelectorAll('.nom-hypnos__ingredient-card')];
        const cardCount = originalCards.length;
        originalCards.forEach((card, index) => {
          card.dataset.ingredientIndex = String(index);
        });
        let ingredientIndex = 0;
        let autoplayTimer;
        let restartTimer;
        let ingredientVisible = false;
        let ingredientAnimating = false;
        const reduceIngredientMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const ingredientStep = () => {
          const card = ingredientTrack.firstElementChild;
          const styles = getComputedStyle(ingredientTrack);
          const gap = parseFloat(styles.columnGap || styles.gap) || 0;
          return card.getBoundingClientRect().width + gap;
        };

        const readIngredientIndex = () => {
          ingredientIndex = Number(ingredientTrack.firstElementChild?.dataset.ingredientIndex || 0);
        };

        const syncIngredientDots = () => {
          ingredientDots.forEach((dot, dotIndex) => {
            const isActive = dotIndex === ingredientIndex;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-current', String(isActive));
          });
        };

        const resetIngredientTrack = () => {
          ingredientTrack.scrollTo({ left: 0, behavior: 'auto' });
        };

        const scrollIngredients = (direction) => {
          if (ingredientAnimating) return;
          const step = ingredientStep();
          if (!step || cardCount < 2) return;
          ingredientAnimating = true;
          const duration = reduceIngredientMotion ? 0 : 460;

          if (direction > 0) {
            ingredientTrack.scrollTo({ left: step, behavior: reduceIngredientMotion ? 'auto' : 'smooth' });
            window.setTimeout(() => {
              ingredientTrack.append(ingredientTrack.firstElementChild);
              resetIngredientTrack();
              readIngredientIndex();
              syncIngredientDots();
              ingredientAnimating = false;
            }, duration);
            return;
          }

          ingredientTrack.prepend(ingredientTrack.lastElementChild);
          ingredientTrack.scrollTo({ left: step, behavior: 'auto' });
          requestAnimationFrame(() => {
            ingredientTrack.scrollTo({ left: 0, behavior: reduceIngredientMotion ? 'auto' : 'smooth' });
            window.setTimeout(() => {
              readIngredientIndex();
              syncIngredientDots();
              ingredientAnimating = false;
            }, duration);
          });
        };

        const stopIngredientAutoplay = () => window.clearInterval(autoplayTimer);
        const startIngredientAutoplay = () => {
          stopIngredientAutoplay();
          if (reduceIngredientMotion || document.hidden || !ingredientVisible) return;
          autoplayTimer = window.setInterval(() => scrollIngredients(1), 2100);
        };
        const restartIngredientAutoplay = () => {
          stopIngredientAutoplay();
          window.clearTimeout(restartTimer);
          restartTimer = window.setTimeout(startIngredientAutoplay, 2100);
        };

        section.querySelector('[data-ingredient-previous]')?.addEventListener('click', () => {
          scrollIngredients(-1);
          restartIngredientAutoplay();
        });
        section.querySelector('[data-ingredient-next]')?.addEventListener('click', () => {
          scrollIngredients(1);
          restartIngredientAutoplay();
        });
        ingredientDots.forEach((dot, dotIndex) => {
          dot.addEventListener('click', () => {
            const targetCard = originalCards[dotIndex];
            while (ingredientTrack.firstElementChild !== targetCard) {
              ingredientTrack.append(ingredientTrack.firstElementChild);
            }
            resetIngredientTrack();
            readIngredientIndex();
            syncIngredientDots();
            restartIngredientAutoplay();
          });
        });
        ingredientTrack.addEventListener('pointerenter', stopIngredientAutoplay);
        ingredientTrack.addEventListener('pointerleave', startIngredientAutoplay);
        ingredientTrack.addEventListener('focusin', stopIngredientAutoplay);
        ingredientTrack.addEventListener('focusout', startIngredientAutoplay);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) stopIngredientAutoplay();
          else startIngredientAutoplay();
        });
        window.addEventListener('resize', resetIngredientTrack, { passive: true });
        if ('IntersectionObserver' in window) {
          const ingredientVisibilityObserver = new IntersectionObserver(([entry]) => {
            ingredientVisible = entry.isIntersecting;
            if (ingredientVisible) startIngredientAutoplay();
            else stopIngredientAutoplay();
          }, { threshold: 0.15 });
          ingredientVisibilityObserver.observe(ingredientTrack);
        } else {
          ingredientVisible = true;
        }
        requestAnimationFrame(() => {
          resetIngredientTrack();
          readIngredientIndex();
          syncIngredientDots();
          startIngredientAutoplay();
        });
      };

      if (ingredientTrack && 'IntersectionObserver' in window) {
        const ingredientInitObserver = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting) return;
          ingredientInitObserver.disconnect();
          initIngredientCarousel();
        }, { rootMargin: '400px 0px' });
        ingredientInitObserver.observe(ingredientTrack);
      } else {
        initIngredientCarousel();
      }
    };

    document.querySelectorAll('[data-nom-hypnos]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-nom-hypnos]');
      if (section) init(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
